import { connect } from 'react-redux';
import actions from '../actions';
import { InterpreterCache } from '../gcode/interpreter-cache';

import ProbingProgram from '../components/ProbingProgram';
import machines from '../machines';

export function dispatchActionsToSetMachineToProbingOperation(probingOperationIndex, dispatch) {
  const i = probingOperationIndex;

  // This uses the fact that the InterpreterCache keeps an array of line numbers
  // that represent the beginning of each chunk of comment lines that usually indicate
  // the start of a tool path. The simulator uses this array for jumping to the next
  // or previous tool path. In this case, the probing program generates G code with such a
  // comment line for every probing operation. The first value of the array is always 0,
  // the beginning of the G code program, so the first line of G code for a given operation, i,
  // is toolPaths[i+1] and the last line of G code would be toolPaths[i+2]-1 (because 
  // toolPaths[i+2] is the first line of the next operation.
  const interpreterCache = InterpreterCache.getInstance();
  const toolPaths = interpreterCache.toolPaths;

  const lineAtEndOfProbingOperation = toolPaths[i+2]-1;
  const currentTime = interpreterCache.timeAtLine(lineAtEndOfProbingOperation);
  const machineState = interpreterCache.machineStateAtLineAndTime(lineAtEndOfProbingOperation, currentTime);
  dispatch(actions.machineState.set(machineState));
  dispatch(actions.interpreter.setCurrentLineAndTimeNoUpdates({ currentLine: lineAtEndOfProbingOperation, currentTime }));
}

export default connect(
  (state, ownProps) => ({
    program: state.probing.program,
    highlightedOperation: state.probing.highlightedOperation,
    activeOperation: state.probing.activeOperation,
    machine: machines[state.machineState.machine]
  }),
  (dispatch, ownProps) => ({
    onSetHighlightedOperation: (i) => {
      dispatch(actions.probing.setHighlightedOperation(i));
    },
    onSetActiveOperation: (i) => {
      dispatch(actions.probing.setActiveOperation(i));
      dispatchActionsToSetMachineToProbingOperation(i, dispatch);
    },
    onSetJoints: (joints) => {
      dispatch(actions.machineState.joints.set(joints));
    },
    onSave: (index, args) => {
      dispatch(actions.probing.updateOperation({ index, object: { args } }));
    },
    onRevert: (index) => {
    }
  })
)(ProbingProgram);
